import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and tailwind-merge for deduplication
 * 
 * @param inputs - Class values to merge
 * @returns Merged className string
 * 
 * @example
 * cn('px-2 py-1', isActive && 'bg-blue-500', 'text-white')
 * // => 'px-2 py-1 bg-blue-500 text-white'
 * 
 * cn('px-2', 'px-4') // tailwind-merge resolves conflicts
 * // => 'px-4'
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
